var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScheduledTime = function SvgScheduledTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 0a.5.5 0 0 1 .5.5v.52a7 7 0 0 1 6.48 6.48h.52a.5.5 0 0 1 0 1h-.52a7 7 0 0 1-6.48 6.48v.52a.5.5 0 0 1-1 0v-.52A7 7 0 0 1 1.02 8.5H.5a.5.5 0 0 1 0-1h.52A7 7 0 0 1 7.5 1.02V.5A.5.5 0 0 1 8 0m.5 4.5a.5.5 0 0 1-1 0V2.188A5.83 5.83 0 0 0 2.188 7.5H4.5a.5.5 0 0 1 0 1H2.188A5.826 5.826 0 0 0 7.5 13.81V11.5a.5.5 0 0 1 1 0v2.31a5.826 5.826 0 0 0 5.312-5.31H11.5a.5.5 0 0 1 0-1h2.312A5.83 5.83 0 0 0 8.5 2.188zM8 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
  })));
};
export default SvgScheduledTime;